export default function Privacy() {
  return (
    <div className="content-div">
      <div className="wrap" role="document">
        <div className="band band-default">
          <div className="container" style={{ marginLeft: "10vw", marginRight: "10vw" }}>
            <div className="row">
              <div className="col-sm-8">
                <br />
                <h1 style={{ fontSize: "3.0em" }}>Privacy Policy of 6hats.ai</h1>
                <br />
                <p>In a nutshell, our privacy policy is simple: we don't collect or share personal information without your consent.</p>
                <p>We will not, under any circumstances, give out or sell your data, files, or any information related to your use of the platform to third parties.</p>
                <p>We will never send you unsolicited emails. You will only receive communications that are important and directly related to your 6hats.ai usage, such as responses to requests or important updates.</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}